import { IModel } from 'core-ts-types';
import { Datasource, IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';
import * as _4 from 'lodash4';
export class PreferencesSelectionModel implements IModel {
  private _arePreferencesSelected: boolean;
  update(source: boolean) {
    return this;
  }
  clear(): PreferencesSelectionModel {
    return this;
  }

  write(source: boolean): PreferencesSelectionModel {
    // receives `prefs_first_visit` flag from backend
    this._arePreferencesSelected = !source;
    return this;
  }

  arePreferencesSelected() {
    return this._arePreferencesSelected;
  }

  read(): boolean {
    return this._arePreferencesSelected;
  }
}

angular.module('capability-ng-scheduler').service('ngPreferencesSelectionModel', PreferencesSelectionModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/models/preferences_selection_model.ts